var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGdprIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.75C9.92893 13.75 8.25 12.0711 8.25 10C8.25 7.92893 9.92893 6.25 12 6.25C14.0711 6.25 15.75 7.92893 15.75 10C15.75 12.0711 14.0711 13.75 12 13.75ZM9.75 10C9.75 11.2426 10.7574 12.25 12 12.25C13.2426 12.25 14.25 11.2426 14.25 10C14.25 8.75736 13.2426 7.75 12 7.75C10.7574 7.75 9.75 8.75736 9.75 10Z",
    fill: "#04B7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6462 2.36419L18.6646 4.70139C20.1321 5.38485 21.0953 6.92095 20.9925 8.60032C20.5981 15.0419 18.8406 17.9539 14.0899 21.3322C12.8361 22.2238 11.1823 22.2216 9.92759 21.3315C5.1914 17.9715 3.36871 15.1001 3.00617 8.57773C2.91343 6.90939 3.87515 5.38942 5.33248 4.71069L10.3708 2.36419C11.4134 1.8786 12.6036 1.8786 13.6462 2.36419ZM11.0041 3.72395L5.96577 6.07045C5.04625 6.4987 4.44627 7.45854 4.50385 8.49448C4.67855 11.6373 5.19768 13.7317 6.13574 15.408C6.42786 15.93 6.76848 16.4256 7.16813 16.9096C8.6089 15.8585 10.2473 15.25 11.9999 15.25C13.7511 15.25 15.3885 15.8576 16.8285 16.9074C17.2297 16.4172 17.5706 15.9158 17.8625 15.3885C18.7938 13.7062 19.305 11.6171 19.4953 8.50865C19.5593 7.46292 18.9566 6.49212 18.0313 6.06115L13.0129 3.72395C12.3718 3.42535 11.6452 3.42535 11.0041 3.72395ZM10.7955 20.1081C9.77095 19.3812 8.91684 18.6981 8.20181 18.0146C9.38442 17.1902 10.6693 16.75 11.9999 16.75C13.3312 16.75 14.6168 17.1908 15.8001 18.0161C15.09 18.7003 14.2409 19.3842 13.2206 20.1098C12.4889 20.6301 11.532 20.6306 10.7955 20.1081Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdprIcon);
export default __webpack_public_path__ + "static/media/GdprIcon.1a4369fdb2aceb457da882fe2cf32bde.svg";
export { ForwardRef as ReactComponent };